module.exports = __webpack_public_path__ + "img/browse-vehicles-search-hero-ford.a873b11c.png";